import React, { Fragment, useState, useEffect } from "react";
import { Breadcrumbs, Btn, H4 } from "../../AbstractElements";
import { useSelector } from "react-redux";
import { Container, Row, Col, Card, CardBody, Form, FormGroup, Label, Input, Spinner, Button } from "reactstrap";
import Select from "react-select";
import { MultiDropzone } from "../../myConstants/MultiDropzone";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";

const categories = [
  { value: "dailyworkout", label: "Daily Workout" },
  { value: "workoutprogram", label: "Workout Programs" },
  { value: "singleexercise", label: "Single Exercise" },
  { value: "challenges", label: "Fitness Challenge" },
];

const CreateExercise = () => {
  const token = useSelector((state) => state.auth.userToken);
  const admin = useSelector((state) => state.auth.userInfo._id);
  const [loader, setLoader] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [category, setCategory] = useState(null);
  const [images, setImages] = useState([]);
  const [currentVideoUrl, setCurrentVideoUrl] = useState(""); // Add this state
  const [formData, setFormData] = useState({
    workOutName: "",
    duration: "",
    calories: "",
    reps: "",
    setLength: "",
    totalSets: "",
    description: "",
    typeS: "single", // Default value
    side: "left", // Default value
    image: "",
    video: "",
  });
  const [editMode, setEditMode] = useState(false);
  const [exerciseId, setExerciseId] = useState(null);
  const { id } = useParams();

  useEffect(() => {
    if (id) {
      setEditMode(true);
      setExerciseId(id);
    }
  }, [id]);

  useEffect(() => {
    if (editMode && exerciseId) {
      fetchExerciseById(exerciseId);
    }
  }, [editMode, exerciseId]);

  const history = useNavigate();

  const fetchExerciseById = async (id) => {
    try {
      const response = await axios.get(
        `https://ovah-1-production.up.railway.app/api/add/getExerciseById/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const exerciseData = response.data.exercise;
      setFormData({
        workOutName: exerciseData.workOutName,
        duration: exerciseData.duration,
        calories: exerciseData.calories,
        reps: exerciseData.reps,
        setLength: exerciseData.setLength,
        totalSets: exerciseData.totalSets,
        description: exerciseData.description,
        typeS: exerciseData.typeS,
        side: exerciseData.side,
        image: exerciseData.exercisePicUrl,
        video: exerciseData.exerciseVideoUrl,
      });
      setImages([{ file: exerciseData.exercisePicUrl }]); // Assuming image is a URL
      setCategory(exerciseData.workOutType);
      setCurrentVideoUrl(exerciseData.exerciseVideoUrl); // Set the current video URL
    } catch (error) {
      console.error("Error fetching exercise:", error);
    }
  };

  const handleCategoryChange = (selectedOption) => {
    setCategory(selectedOption.value);
  };

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData({
      ...formData,
      [id]: value,
    });
  };

  const handleImageChange = (newImages) => {
    setImages(newImages);
  };

  const handleVideoChange = (e) => {
    const file = e.target.files[0];
    setFormData({
      ...formData,
      video: file,
    });
    setCurrentVideoUrl(URL.createObjectURL(file)); // Preview the new video
  };

  const handleDeleteVideo = () => {
    setFormData({
      ...formData,
      video: "",
    });
    setCurrentVideoUrl(""); // Clear the video preview
  };

  const handleAddExercise = async (e) => {
    e.preventDefault();
    setLoader(true);

    const data = new FormData();
    data.append("admin", admin);
    data.append("workOutName", formData.workOutName);
    data.append("duration", formData.duration);
    data.append("calories", formData.calories);
    data.append("reps", formData.reps);
    data.append("setLength", formData.setLength);
    data.append("totalSets", formData.totalSets);
    data.append("description", formData.description);
    data.append("typeS", formData.typeS);
    data.append("side", formData.side);
    data.append("video", formData.video);

    const imageFile = images[0]; // Assuming images[0] contains a File object
    data.append("image", imageFile);

    try {
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      };

      let response;
      if (editMode && exerciseId) {
        response = await axios.put(
          `https://ovah-1-production.up.railway.app/api/add/editExercises/${exerciseId}`,
          data,
          config
        );
      } else {
        response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/add/addExercise`,
          data,
          config
        );
      }

      if (response.status === 201 || response.status === 200) {
        toast.success(response.data.message);
        setLoader(false);
        setFormSubmitted(true);
        setFormData({
          workOutName: "",
          duration: "",
          calories: "",
          reps: "",
          setLength: "",
          totalSets: "",
          description: "",
          typeS: "single",
          side: "left",
          image: "",
          video: "",
        });
        setCategory(null);
        setEditMode(false);
        setExerciseId(null);
        history("/excercise/view");
      }
    } catch (error) {
      console.error("Error adding/updating exercise:", error);
      setLoader(false);
    }
  };

  const handleCancel = () => {
    setFormData({
      workOutName: "",
      duration: "",
      calories: "",
      reps: "",
      setLength: "",
      totalSets: "",
      description: "",
      typeS: "single",
      side: "left",
      image: "",
      video: "",
    });
    setImages([]);
    setCategory(null);
    setEditMode(false);
    setExerciseId(null);
  };

  return (
    <Fragment>
      <Breadcrumbs
        parent="Exercises"
        title={editMode ? "Edit Exercise" : "Create Exercise"}
        mainTitle="Exercises"
      />
      {!loader ? (
        <Container fluid={true}>
          <H4>{editMode ? "Edit Exercise" : "Create Exercise"}</H4>
          <Row>
            <Col sm="12">
              <Card>
                <CardBody>
                  <Form className="theme-form" onSubmit={handleAddExercise}>
                    <FormGroup>
                      <Label for="category">Category</Label>
                      <Select
                        options={categories}
                        onChange={handleCategoryChange}
                        placeholder="Select a category..."
                        value={categories.find((c) => c.value === category)}
                      />
                    </FormGroup>
                    <Row>
                      <Col md="4">
                        <FormGroup>
                          <Label for="workOutName">Workout Name</Label>
                          <Input
                            type="text"
                            id="workOutName"
                            value={formData.workOutName}
                            onChange={handleInputChange}
                            required
                          />
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup>
                          <Label for="duration">Duration (minutes)</Label>
                          <Input
                            type="number"
                            id="duration"
                            value={formData.duration}
                            onChange={handleInputChange}
                            required
                          />
                        </FormGroup>
                      </Col>
                   {!id &&   <Col md="4">
                        <FormGroup>
                          <Label for="calories">Calories</Label>
                          <Input
                            type="number"
                            id="calories"
                            value={formData.calories}
                            onChange={handleInputChange}
                            required
                          />
                        </FormGroup>
                      </Col>}
                    </Row>
                    <Row>
                      <Col md="4">
                        <FormGroup>
                          <Label for="reps">Reps</Label>
                          <Input
                            type="number"
                            id="reps"
                            value={formData.reps}
                            onChange={handleInputChange}
                            required
                          />
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup>
                          <Label for="setLength">Set Length</Label>
                          <Input
                            type="number"
                            id="setLength"
                            value={formData.setLength}
                            onChange={handleInputChange}
                            required
                          />
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup>
                          <Label for="totalSets">Total Sets</Label>
                          <Input
                            type="number"
                            id="totalSets"
                            value={formData.totalSets}
                            onChange={handleInputChange}
                            required
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="4">
                        <FormGroup>
                          <Label for="description">Description</Label>
                          <Input
                            type="text"
                            id="description"
                            value={formData.description}
                            onChange={handleInputChange}
                            required
                          />
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup>
                          <Label for="typeS">Type</Label>
                          <Input
                            type="select"
                            id="typeS"
                            value={formData.typeS}
                            onChange={handleInputChange}
                          >
                            <option value="single">Single</option>
                            <option value="multi">Multi</option>
                          </Input>
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup>
                          <Label for="side">Side</Label>
                          <Input
                            type="select"
                            id="side"
                            value={formData.side}
                            onChange={handleInputChange}
                          >
                            <option value="left">Left</option>
                            <option value="right">Right</option>
                            <option value="both">Both</option>
                          </Input>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <FormGroup>
                        <Col sm="12">
                          <Label for="image">Exercise Picture URL</Label>
                          <MultiDropzone
                            id="image"
                            images={images}
                            setImages={handleImageChange}
                          />
                        </Col>
                      </FormGroup>
                    </Row>
                    <Row>
                    <Col md="6">
  <FormGroup>
    <Label for="video">Exercise Video</Label>
    {currentVideoUrl && (
      <div>
        <p>{decodeURIComponent(currentVideoUrl.split('/').pop())}</p> {/* Display decoded video name */}
        <Button color="danger" onClick={handleDeleteVideo}>
          Delete Video
        </Button>
      </div>
    )}
    <Input
      type="file"
      id="video"
      accept="video/*"
      onChange={handleVideoChange}
    />
  </FormGroup>
</Col>

                    </Row>
                
                    <div className="text-right">
  <Btn
    attrBtn={{
      color: "primary",
      type: "submit",
      className: "mr-2",
      style: { marginRight: "10px" },  // Inline style for margin-right
    }}
  >
    {editMode ? "Update Exercise" : "Create Exercise"}
  </Btn>
  <Btn
    attrBtn={{
      color: "secondary",
      type: "button",
      style: { marginLeft: "10px" },  // Inline style for margin-left
      onClick: handleCancel,
    }}
  >
    Cancel
  </Btn>
</div>


                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      ) : (
        <div className="text-center my-5">
                <Spinner style={{ width: '3rem', height: '3rem' }} />
              </div>
      )}
    </Fragment>
  );
};

export default CreateExercise;

// import React, { Fragment, useState, useEffect } from "react";
// import { Breadcrumbs, Btn, H4 } from "../../AbstractElements";
// import { useSelector } from "react-redux";
// import {
//   Container,
//   Row,
//   Col,
//   Card,
//   CardBody,
//   Form,
//   FormGroup,
//   Label,
//   Input,
// } from "reactstrap";
// import Select from "react-select";
// import { MultiDropzone } from "../../myConstants/MultiDropzone";
// import UploadProjectFileClass from "./comp/UploadProjectFile";
// import axios from "axios";
// import { toast } from "react-toastify";
// import { useParams } from "react-router-dom"; // Import useParams to extract URL parameters

// const categories = [
//   { value: "dailyworkout", label: "Daily Workout" },
//   { value: "workoutprogram", label: "Workout Programs" },
//   { value: "singleexercise", label: "Single Exercise" },
//   { value: "challenges", label: "Fitness Challenge" },
// ];

// const CreateExercise = () => {
//   const token = useSelector((state) => state.auth.userToken);
//   const admin = useSelector((state) => state.auth.userInfo._id);
//   const [loader, setLoader] = useState(false);
//   const [formSubmitted, setFormSubmitted] = useState(false);
//   const [category, setCategory] = useState(null);
//   const [images, setImages] = useState([]);
//   const [formData, setFormData] = useState({
//     workOutName: "",
//     duration: "",
//     calories: "",
//     reps: "",
//     setLength: "",
//     totalSets: "",
//     description: "",
//     typeS: "single", // Default value
//     side: "left", // Default value
//     image: "",
//     video: "",
//   });
//   const [editMode, setEditMode] = useState(false);
//   const [exerciseId, setExerciseId] = useState(null);
//   const { id } = useParams(); // Extract ID from URL parameters

//   useEffect(() => {
//     if (id) {
//       // If ID exists in URL, set edit mode and exercise ID
//       setEditMode(true);
//       setExerciseId(id);
//     }
//   }, [id]);

//   useEffect(() => {
//     if (editMode && exerciseId) {
//       // Fetch exercise details by ID
//       fetchExerciseById(exerciseId);
//     }
//   }, [editMode, exerciseId]);

//   const fetchExerciseById = async (id) => {
//     try {
//       const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/exercises/${id}`, {
//         headers: {
//           Authorization: "Bearer " + token,
//         },
//       });
//       const exerciseData = response.data; // Adjust this based on your API response structure
//       setFormData({
//         workOutName: exerciseData.workOutName,
//         duration: exerciseData.duration,
//         calories: exerciseData.calories,
//         reps: exerciseData.reps,
//         setLength: exerciseData.setLength,
//         totalSets: exerciseData.totalSets,
//         description: exerciseData.description,
//         typeS: exerciseData.typeS,
//         side: exerciseData.side,
//         image: exerciseData.image,
//         video: exerciseData.video,
//       });
//       setCategory(exerciseData.workOutType);
//     } catch (error) {
//       console.error("Error fetching exercise:", error);
//     }
//   };

//   const handleCategoryChange = (selectedOption) => {
//     setCategory(selectedOption.value);
//   };

//   const handleInputChange = (e) => {
//     const { id, value } = e.target;
//     setFormData({
//       ...formData,
//       [id]: value,
//     });
//   };

//   const handleImageChange = (newImages) => {
//     setImages(newImages);
//   };

//   const handleAddExercise = async (e) => {
//     e.preventDefault();
//     setLoader(true);

//     const data = {
//       ...formData,
//       admin: admin,
//       workOutType: category,
//       image: images.length > 0 ? images[0].url : "",
//     };

//     try {
//       let config = {
//         headers: {
//           Authorization: "Bearer " + token,
//         },
//       };

//       let response;
//       if (editMode && exerciseId) {
//         // Update existing exercise
//         response = await axios.put(`${process.env.REACT_APP_API_BASE_URL}/exercises/${exerciseId}`, data, config);
//       } else {
//         // Add new exercise
//         response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/add/addExercise`, data, config);
//       }

//       if (response.status === 201 || response.status === 200) {
//         toast.success(response.data.message);
//         setLoader(false);
//         console.log("Exercise Added/Updated:", response);
//         setFormSubmitted(true);
//         setFormData({
//           workOutName: "",
//           duration: "",
//           calories: "",
//           reps: "",
//           setLength: "",
//           totalSets: "",
//           description: "",
//           typeS: "single", // Default value
//           side: "left", // Default value
//           image: "",
//           video: "",
//         });
//         setCategory(null);
//         setEditMode(false);
//         setExerciseId(null);
//       }
//     } catch (error) {
//       console.error("Error adding/updating exercise:", error);
//     }
//   };

//   const handleCancel = () => {
//     // Reset form data or handle cancel action if needed
//     setFormData({
//       workOutName: "",
//       duration: "",
//       calories: "",
//       reps: "",
//       setLength: "",
//       totalSets: "",
//       description: "",
//       typeS: "single",
//       side: "left",
//       image: "",
//       video: "",
//     });
//     setImages([]);
//     setCategory(null);
//     setEditMode(false);
//     setExerciseId(null);
//   };

//   return (
//     <Fragment>
//       <Breadcrumbs parent="Exercises" title={editMode ? "Edit Exercise" : "Create Exercise"} mainTitle="Exercises" />
//       {!loader ? (
//         <Container fluid={true}>
//           <H4>{editMode ? "Edit Exercise" : "Create Exercise"}</H4>
//           <Row>
//             <Col sm="12">
//               <Card>
//                 <CardBody>
//                   <Form className="theme-form" onSubmit={handleAddExercise}>
//                     <FormGroup>
//                       <Label for="category">Category</Label>
//                       <Select
//                         options={categories}
//                         onChange={handleCategoryChange}
//                         placeholder="Select a category..."
//                         value={categories.find((c) => c.value === category)}
//                       />
//                     </FormGroup>
//                     <Row>
//                       <Col md="4">
//                         <FormGroup>
//                           <Label for="workOutName">Workout Name</Label>
//                           <Input
//                             type="text"
//                             id="workOutName"
//                             value={formData.workOutName}
//                             onChange={handleInputChange}
//                             required
//                           />
//                         </FormGroup>
//                       </Col>
//                       <Col md="4">
//                         <FormGroup>
//                           <Label for="duration">Duration (minutes)</Label>
//                           <Input
//                             type="number"
//                             id="duration"
//                             value={formData.duration}
//                             onChange={handleInputChange}
//                             required
//                           />
//                         </FormGroup>
//                       </Col>
//                       <Col md="4">
//                         <FormGroup>
//                           <Label for="calories">Calories</Label>
//                           <Input
//                             type="number"
//                             id="calories"
//                             value={formData.calories}
//                             onChange={handleInputChange}
//                             required
//                           />
//                         </FormGroup>
//                       </Col>
//                     </Row>
//                     <Row>
//                       <Col md="4">
//                         <FormGroup>
//                           <Label for="reps">Reps</Label>
//                           <Input
//                             type="number"
//                             id="reps"
//                             value={formData.reps}
//                             onChange={handleInputChange}
//                             required
//                           />
//                         </FormGroup>
//                       </Col>
//                       <Col md="4">
//                         <FormGroup>
//                           <Label for="setLength">Set Length</Label>
//                           <Input
//                             type="number"
//                             id="setLength"
//                             value={formData.setLength}
//                             onChange={handleInputChange}
//                             required
//                           />
//                         </FormGroup>
//                       </Col>
//                       <Col md="4">
//                         <FormGroup>
//                           <Label for="totalSets">Total Sets</Label>
//                           <Input
//                             type="number"
//                             id="totalSets"
//                             value={formData.totalSets}
//                             onChange={handleInputChange}
//                             required
//                           />
//                         </FormGroup>
//                       </Col>
//                     </Row>
//                     <Row>
//                       <Col md="4">
//                         <FormGroup>
//                           <Label for="description">Description</Label>
//                           <Input
//                             type="text"
//                             id="description"
//                             value={formData.description}
//                             onChange={handleInputChange}
//                             required
//                           />
//                         </FormGroup>
//                       </Col>
//                       <Col md="4">
//                         <FormGroup>
//                           <Label for="typeS">Type</Label>
//                           <Input
//                             type="select"
//                             id="typeS"
//                             value={formData.typeS}
//                             onChange={handleInputChange}
//                             required
//                           >
//                             <option value="single">Single</option>
//                             <option value="double">Double</option>
//                           </Input>
//                         </FormGroup>
//                       </Col>
//                       <Col md="4">
//                         <FormGroup>
//                           <Label for="side">Side</Label>
//                           <Input
//                             type="select"
//                             id="side"
//                             value={formData.side}
//                             onChange={handleInputChange}
//                           >
//                             <option value="left">Left</option>
//                             <option value="right">Right</option>
//                           </Input>
//                         </FormGroup>
//                       </Col>
//                     </Row>
//                     <Row>
//                       <FormGroup>
//                         <Col sm="12">
//                           <Label for="image">Exercise Picture URL</Label>
//                           <MultiDropzone
//                             id="image"
//                             images={images}
//                             setImages={handleImageChange}
//                           />
//                         </Col>
//                       </FormGroup>
//                     </Row>
//                     <Row>
//                       <FormGroup>
//                         <Col sm="12">
//                           <Label for="video">Exercise Video URL</Label>
//                           <UploadProjectFileClass
//                             id="video"
//                             register={() => {}}
//                             errors={{}}
//                             value={formData.video}
//                             onChange={(e) =>
//                               setFormData({
//                                 ...formData,
//                                 video: e.target.value,
//                               })
//                             }
//                           />
//                         </Col>
//                       </FormGroup>
//                     </Row>
//                     <Row>
//                       <Col>
//                         <div className="text-end">
//                           <Btn
//                             attrBtn={{
//                               color: "success",
//                               className: "me-3",
//                               type: "submit",
//                             }}
//                           >
//                             {editMode ? "Update Exercise" : "Add Exercise"}
//                           </Btn>
//                           <Btn
//                             attrBtn={{ color: "warning", type: "button" }}
//                             onClick={handleCancel}
//                           >
//                             Cancel
//                           </Btn>
//                         </div>
//                       </Col>
//                     </Row>
//                   </Form>
//                 </CardBody>
//               </Card>
//             </Col>
//           </Row>
//         </Container>
//       ) : (
//         <div>Loading...</div>
//       )}
//     </Fragment>
//   );
// };

// export default CreateExercise;

// // import React, { Fragment, useState } from "react";
// // import { Breadcrumbs, Btn, H4, Spinner } from "../../AbstractElements";
// // import { useSelector } from "react-redux";
// // import {
// //   Container,
// //   Row,
// //   Col,
// //   Card,
// //   CardBody,
// //   Form,
// //   FormGroup,
// //   Label,
// //   Input,
// // } from "reactstrap";
// // import Select from "react-select";
// // import { MultiDropzone } from "../../myConstants/MultiDropzone";
// // import UploadProjectFileClass from "./comp/UploadProjectFile";
// // import axios from "axios";
// // import { toast } from "react-toastify";

// // const categories = [
// //   { value: "dailyworkout", label: "Daily Workout" },
// //   { value: "workoutprogram", label: "Workout Programs" },
// //   { value: "singleexercise", label: "Single Exercise" },
// //   { value: "challenges", label: "Fitness Challenge" },
// // ];

// // const CreateExercise = () => {
// //   const token = useSelector((state) => state.auth.userToken);
// //   const admin = useSelector((state) => state.auth.userInfo._id);
// //   const [loader, setLoader] = useState(false);

// //   const [formSubmitted, setFormSubmitted] = useState(false);
// //   const [category, setCategory] = useState(null);
// //   const [images, setImages] = useState([]);
// //   const [formData, setFormData] = useState({
// //     workOutName: "",
// //     duration: "",
// //     calories: "",
// //     reps: "",
// //     setLength: "",
// //     totalSets: "",
// //     description: "",
// //     typeS: "single", // Default value
// //     side: "left", // Default value
// //     image: "",
// //     video: "",
// //   });
// //   const Data = [
// //     {
// //       id: 2,
// //       heading: "Loader 3",
// //       spinnerClass: "loader-3",
// //     },
// //   ];
// //   console.log("🚀 ~ CreateExercise ~ formData:", formData)
// //   const handleCategoryChange = (selectedOption) => {
// //     setCategory(selectedOption.value);
// //   };

// //   const handleInputChange = (e) => {
// //     const { id, value } = e.target;
// //     setFormData({
// //       ...formData,
// //       [id]: value,
// //     });
// //   };

// //   const handleImageChange = (newImages) => {
// //     setImages(newImages);
// //   };

// //   const handleAddExercise = async (e) => {
// //     e.preventDefault();
// //     setLoader(true);

// //     const data = {
// //       ...formData,
// //       admin: admin,
// //       workOutType: category,
// //       image: images.length > 0 ? images[0].url : "",
// //     };
    
// //     console.log("🚀 ~ handleAddExercise ~ data:", data)
// //     try {
// //       let config = {
// //         headers: {
// //           Authorization: "Bearer " + token,
// //         },
// //       };

// //       const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/add/addExercise`,
// //         data,
// //         config
// //       );
// //       console.log("🚀 ~ handleAddExercise ~ response:", response)
// //     if(response.status===201){
// //       toast.success(response.data.message);
// //       setLoader(false);
// //       console.log("Exercise Added:", response);
// //       setFormSubmitted(true);
// //       setFormData({    workOutName: "",
// //         duration: "",
// //         calories: "",
// //         reps: "",
// //         setLength: "",
// //         totalSets: "",
// //         description: "",
// //         typeS: "", // Default value
// //         side: "", // Default value
// //         image: "",
// //         video: "",
// //       });
// //     }
// //     } catch (error) {
// //       console.error("Error adding exercise:", error);
// //     }
// //   };

// //   const handleCancel = () => {
// //     // Reset form data or handle cancel action if needed
// //     setFormData({
// //       workOutName: "",
// //       duration: "",
// //       calories: "",
// //       reps: "",
// //       setLength: "",
// //       totalSets: "",
// //       description: "",
// //       typeS: "single",
// //       side: "",
// //       image: "",
// //       video: "",
// //     });
// //     setImages([]);
// //   };

// //   return (
// //     <Fragment>
// //       <Breadcrumbs parent="Exercises" title="Create Exercise" mainTitle="Exercises" />
// //     {!loader ?(  <Container fluid={true}>
// //         <H4>Create Exercise</H4>
// //         <Row>
// //           <Col sm="12">
// //             <Card>
// //               <CardBody>
// //                 <Form className="theme-form" onSubmit={handleAddExercise}>
// //                   <FormGroup>
// //                     <Label for="category">Category</Label>
// //                     <Select
// //                       options={categories}
// //                       onChange={handleCategoryChange}
// //                       placeholder="Select a category..."
// //                     />
// //                   </FormGroup>
// //                   <Row>
// //                     <Col md="4">
// //                       <FormGroup>
// //                         <Label for="workOutName">Workout Name</Label>
// //                         <Input
// //                           type="text"
// //                           id="workOutName"
// //                           value={formData.workOutName}
// //                           onChange={handleInputChange}
// //                           required
// //                         />
// //                       </FormGroup>
// //                     </Col>
// //                     <Col md="4">
// //                       <FormGroup>
// //                         <Label for="duration">Duration (minutes)</Label>
// //                         <Input
// //                           type="number"
// //                           id="duration"
// //                           value={formData.duration}
// //                           onChange={handleInputChange}
// //                           required
// //                         />
// //                       </FormGroup>
// //                     </Col>
// //                     <Col md="4">
// //                       <FormGroup>
// //                         <Label for="calories">Calories</Label>
// //                         <Input
// //                           type="number"
// //                           id="calories"
// //                           value={formData.calories}
// //                           onChange={handleInputChange}
// //                           required
// //                         />
// //                       </FormGroup>
// //                     </Col>
// //                   </Row>
// //                   <Row>
// //                     <Col md="4">
// //                       <FormGroup>
// //                         <Label for="reps">Reps</Label>
// //                         <Input
// //                           type="number"
// //                           id="reps"
// //                           value={formData.reps}
// //                           onChange={handleInputChange}
// //                           required
// //                         />
// //                       </FormGroup>
// //                     </Col>
// //                     <Col md="4">
// //                       <FormGroup>
// //                         <Label for="setLength">Set Length</Label>
// //                         <Input
// //                           type="number"
// //                           id="setLength"
// //                           value={formData.setLength}
// //                           onChange={handleInputChange}
// //                           required
// //                         />
// //                       </FormGroup>
// //                     </Col>
// //                     <Col md="4">
// //                       <FormGroup>
// //                         <Label for="totalSets">Total Sets</Label>
// //                         <Input
// //                           type="number"
// //                           id="totalSets"
// //                           value={formData.totalSets}
// //                           onChange={handleInputChange}
// //                           required
// //                         />
// //                       </FormGroup>
// //                     </Col>
// //                   </Row>
// //                   <Row>
// //                     <Col md="4">
// //                       <FormGroup>
// //                         <Label for="description">Description</Label>
// //                         <Input
// //                           type="text"
// //                           id="description"
// //                           value={formData.description}
// //                           onChange={handleInputChange}
// //                           required
// //                         />
// //                       </FormGroup>
// //                     </Col>
// //                     <Col md="4">
// //                       <FormGroup>
// //                         <Label for="typeS">Type</Label>
// //                         <Input
// //                           type="select"
// //                           id="typeS"
// //                           value={formData.typeS}
// //                           onChange={handleInputChange}
// //                           required
// //                         >
// //                           <option value="single">Single</option>
// //                           <option value="double">Double</option>
// //                         </Input>
// //                       </FormGroup>
// //                     </Col>
// //                     <Col md="4">
// //                       <FormGroup>
// //                         <Label for="side">Side</Label>
// //                         <Input
// //                           type="select"
// //                           id="side"
// //                           value={formData.side}
// //                           onChange={handleInputChange}
// //                         >
// //                           <option value="left">Left</option>
// //                           <option value="right">Right</option>
// //                         </Input>
// //                       </FormGroup>
// //                     </Col>
// //                   </Row>
// //                   <Row>
// //                     <FormGroup>
// //                       <Col sm="12">
// //                         <Label for="image">Exercise Picture URL</Label>
// //                         <MultiDropzone
// //                           id="image"
// //                           images={images}
// //                           setImages={handleImageChange}
// //                         />
// //                       </Col>
// //                     </FormGroup>
// //                   </Row>
// //                   <Row>
// //                     <FormGroup>
// //                       <Col sm="12">
// //                         <Label for="video">Exercise Video URL</Label>
// //                         <UploadProjectFileClass
// //                           id="video"
// //                           register={() => {}}
// //                           errors={{}}
// //                           value={formData.video}
// //                           onChange={(e) =>
// //                             setFormData({
// //                               ...formData,
// //                               video: e.target.value,
// //                             })
// //                           }
// //                         />
// //                       </Col>
// //                     </FormGroup>
// //                   </Row>
// //                   <Row>
// //                     <Col>
// //                       <div className="text-end">
// //                         <Btn
// //                           attrBtn={{
// //                             color: "success",
// //                             className: "me-3",
// //                             type: "submit",
// //                           }}
// //                         >
// //                           Add Exercise
// //                         </Btn>
// //                         <Btn
// //                           attrBtn={{ color: "warning", type: "button" }}
// //                           onClick={handleCancel}
// //                         >
// //                           Cancel
// //                         </Btn>
// //                       </div>
// //                     </Col>
// //                   </Row>
// //                 </Form>
// //               </CardBody>
// //             </Card>
// //           </Col>
// //         </Row>
// //       </Container>)
// //      :(
// //         <div >
// //           loading......
// //         </div>
// //       )}
// //     </Fragment>
// //   );
// // };

// // export default CreateExercise;



// // import React, { Fragment, useState } from "react";
// // import { Breadcrumbs, Btn, H4 } from "../../AbstractElements";
// // import { useNavigate } from "react-router-dom";
// // import { useForm } from "react-hook-form";
// // import {
// //   Container,
// //   Row,
// //   Col,
// //   Card,
// //   CardBody,
// //   Form,
// //   FormGroup,
// //   Label,
// //   Input,
// // } from "reactstrap";
// // import Select from "react-select";
// // import { MultiDropzone } from "../../myConstants/MultiDropzone";
// // import UploadProjectFileClass from "./comp/UploadProjectFile";

// // const categories = [
// //   { value: "dailyworkout", label: "Daily Workout" },
// //   { value: "workoutprogram", label: "Workout Programs" },
// //   { value: "singleexercise", label: "Single Exercise" },
// //   { value: "challanges", label: "Fitness Challenge" },
// // ];

// // const ExerciseForm = ({ register, errors }) => {
// //   const [images, setImages] = useState([]);

// //   return (
// //     <Fragment>
// //       <Row>
// //         <Col md="4">
// //           <FormGroup>
// //             <Label for="workOutName">Workout Name</Label>
// //             <Input
// //               type="text"
// //               id="workOutName"
// //               {...register("workOutName", { required: true })}
// //             />
// //             {errors.workOutName && <span>This field is required</span>}
// //           </FormGroup>
// //         </Col>
// //         <Col md="4">
// //           <FormGroup>
// //             <Label for="duration">Duration (minutes)</Label>
// //             <Input
// //               type="number"
// //               id="duration"
// //               {...register("duration", { required: true })}
// //             />
// //             {errors.duration && <span>This field is required</span>}
// //           </FormGroup>
// //         </Col>
// //         <Col md="4">
// //           <FormGroup>
// //             <Label for="calories">Calories</Label>
// //             <Input
// //               type="number"
// //               id="calories"
// //               {...register("calories", { required: true })}
// //             />
// //             {errors.calories && <span>This field is required</span>}
// //           </FormGroup>
// //         </Col>
// //       </Row>
// //       <Row>
// //         <Col md="4">
// //           <FormGroup>
// //             <Label for="reps">Reps</Label>
// //             <Input
// //               type="number"
// //               id="reps"
// //               {...register("reps", { required: true })}
// //             />
// //             {errors.reps && <span>This field is required</span>}
// //           </FormGroup>
// //         </Col>
// //         <Col md="4">
// //           <FormGroup>
// //             <Label for="setLength">Set Length</Label>
// //             <Input
// //               type="number"
// //               id="setLength"
// //               {...register("setLength", { required: true })}
// //             />
// //             {errors.setLength && <span>This field is required</span>}
// //           </FormGroup>
// //         </Col>
// //         <Col md="4">
// //           <FormGroup>
// //             <Label for="totalSets">Total Sets</Label>
// //             <Input
// //               type="number"
// //               id="totalSets"
// //               {...register("totalSets", { required: true })}
// //             />
// //             {errors.totalSets && <span>This field is required</span>}
// //           </FormGroup>
// //         </Col>
// //       </Row>

// //       <Row>
// //         <Col md="4">
// //           <FormGroup>
// //             <Label for="description">Description</Label>
// //             <Input type="text" id="description" {...register("description")} />
// //           </FormGroup>
// //         </Col>
// //         <Col md="4">
// //           <FormGroup>
// //             <Label for="typeS">Type</Label>
// //             <Input
// //               type="select"
// //               id="typeS"
// //               {...register("typeS", { required: true })}
// //             >
// //               <option value="single">Single</option>
// //               <option value="double">Double</option>
// //             </Input>
// //             {errors.typeS && <span>This field is required</span>}
// //           </FormGroup>
// //         </Col>
// //         <Col md="4">
// //           <FormGroup>
// //             <Label for="side">Side</Label>
// //             <Input type="select" id="side" {...register("side")}>
// //               <option value="left">Left</option>
// //               <option value="right">Right</option>
// //               <option value="">None</option>
// //             </Input>
// //           </FormGroup>
// //         </Col>
// //       </Row>
// //       <Row>
// //         {/* <Col md="4">
// //         <FormGroup>
// //           <Label for="description">Description</Label>
// //           <Input type="text" id="description" {...register("description")} />
// //         </FormGroup>
// //       </Col> */}
// //         <FormGroup>
// //           {/* <Input type="text" id="image" {...register("image")} /> */}
// //           <Col sm="12">
// //             <Label for="image">Exercise Picture URL</Label>
// //             <MultiDropzone
// //               id="image"
// //               {...register("image")}
// //               images={images}
// //               setImages={setImages}
// //             />
// //           </Col>
// //         </FormGroup>
// //         {/* <Col md="4">
// //         <FormGroup>
// //           <Label for="video">Exercise Video URL</Label>
// //           <Input type="text" id="video" {...register("video")} />
// //         </FormGroup>
// //       </Col> */}
// //       </Row>
// //       <Row>
// //         {/* <Col md="4">
// //         <FormGroup>
// //           <Label for="description">Description</Label>
// //           <Input type="text" id="description" {...register("description")} />
// //         </FormGroup>
// //       </Col> */}
// //         <FormGroup>
// //           {/* <Input type="text" id="image" {...register("image")} /> */}
// //           <Col sm="12">
// //             <Label for="video">Exercise Video URL</Label>

// //             <UploadProjectFileClass
// //               id="video"
// //               {...register("video")}
// //               register={register}
// //               errors={errors}
// //             />
// //           </Col>
// //         </FormGroup>
// //         {/* <Col md="4">
// //         <FormGroup>
// //           <Label for="video">Exercise Video URL</Label>
// //           <Input type="text" id="video" {...register("video")} />
// //         </FormGroup>
// //       </Col> */}
// //       </Row>
// //     </Fragment>
// //   );
// // };

// // const CreateExercise = () => {
// //   const [formSubmitted, setFormSubmitted] = useState(false);
// //   const [category, setCategory] = useState(null);
// //   const [images, setImages] = useState([]);
// //   const {
// //     register,
// //     handleSubmit,
// //     formState: { errors },
// //   } = useForm();

// //   const handleAddExercise = (data) => {
// //     setFormSubmitted(true);
// //     console.log("Exercise Added:", data);
// //   };

// //   return (
// //     <Fragment>
// //       <Breadcrumbs
// //         parent="Exercises"
// //         title="Create Exercise"
// //         mainTitle="Exercises"
// //       />

// //       <Container fluid={true}>
// //         <H4>Create Exercise</H4>
// //         <Row>
// //           <Col sm="12">
// //             <Card>
// //               <CardBody>
// //                 <Form
// //                   className="theme-form"
// //                   onSubmit={handleSubmit(handleAddExercise)}
// //                 >
// //                   <FormGroup>
// //                     <Label for="category">Category</Label>
// //                     <Select
// //                       options={categories}
// //                       onChange={(selectedOption) =>
// //                         setCategory(selectedOption.value)
// //                       }
// //                       placeholder="Select a category..."
// //                     />
// //                   </FormGroup>

// //                   <ExerciseForm register={register} errors={errors} />

// //                   <Row>
// //                     {/* <Col sm="12">
// //                       <MultiDropzone
// //                         images={images}
// //                         setImages={setImages}
// //                       />
// //                     </Col> */}
// //                     <Col>
// //                       <div className="text-end">
// //                         <Btn
// //                           attrBtn={{ color: "success", className: "me-3" }}
// //                           type="submit"
// //                         >
// //                           Add Exercise
// //                         </Btn>
// //                         <Btn attrBtn={{ color: "warning" }} type="reset">
// //                           Cancel
// //                         </Btn>
// //                       </div>
// //                     </Col>
// //                   </Row>
// //                 </Form>
// //               </CardBody>
// //             </Card>
// //           </Col>
// //         </Row>
// //       </Container>

// //       {formSubmitted && category && (
// //         <Container fluid={true}>
// //           <Row>
// //             <Col sm="12">
// //               <Card>
// //                 <CardBody>
// //                   <h5>Added Exercise in {category}</h5>
// //                   {/* Display added exercise details or any other logic */}
// //                 </CardBody>
// //               </Card>
// //             </Col>
// //           </Row>
// //         </Container>
// //       )}
// //     </Fragment>
// //   );
// // };

// // export default CreateExercise;
